import { render, staticRenderFns } from "./search-bulk-messages.vue?vue&type=template&id=6b234fea&scoped=true&"
import script from "./search-bulk-messages.vue?vue&type=script&lang=js&"
export * from "./search-bulk-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b234fea",
  null
  
)

export default component.exports